<template>
  <v-app>
    <status-alert :color="statusColor" :shown.sync="statusShown">
      <template v-if="isArray">
        <ul>
          <li v-for="(message, messageIndex) in statusMessage" :key="`status-${messageIndex}`">{{ message }}</li>
        </ul>
      </template>
      <template v-else>
        {{ statusMessage }}
      </template>
    </status-alert>
    <keep-alive :include="keepAlive" :max="1">
      <router-view/>
    </keep-alive>
    <v-layout>
      <v-dialog v-model="showOptionDialog" persistent max-width="500">
        <v-flex>
          <v-card style="border-radius: 10px">
            <v-container bg fill-height grid-list-md text-xs-center class="mb-0 pb-0">
              <v-layout row wrap align-center class="mb-0 pb-0">
                <v-flex>
                  <v-icon size="100" color="secondary">timer</v-icon>
                </v-flex>
                <v-flex>
                  <v-card-text>
                    <strong>You have been in-active for a prolonged period of time. Please choose to stay logged in or you will be logged out automatically.</strong>
                  </v-card-text>
                </v-flex>
                <v-flex>
                  <v-card-actions>
                    <v-btn color="red" @click="logout">Log Out Now</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="green" @click="refresh">Stay Logged In</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-dialog>
    </v-layout>
    <v-layout>
      <v-dialog v-model="inactiveLogoutPrompt" persistent max-width="500">
        <v-flex>
          <v-card style="border-radius: 10px">
            <v-container bg fill-height grid-list-md text-xs-center class="mb-0 pb-0">
              <v-layout row wrap align-center class="mb-0 pb-0">
                <v-flex>
                  <v-icon size="100" color="secondary">timer</v-icon>
                </v-flex>
                <v-flex>
                  <v-card-text>
                    <strong>You have been in-active for a prolonged period of time and your session has ended. Please sign in again. </strong>
                  </v-card-text>
                </v-flex>
                <v-flex>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green" @click="closeInactivePrompt">OK</v-btn>
                  </v-card-actions>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
import { Bus } from './bus'
import StatusAlert from './components/StatusAlert'

export default {
  name: 'App',
  data () {
    return {
      statusMessage: '',
      statusShown: false,
      statusColor: 'error',
      showOptionDialog: false,
      inactiveLogoutPrompt: false,
      intervalId: null,
      autoLogoutTime: 900000
    }
  },
  components: {
    StatusAlert
  },
  created () {
    this.$store.dispatch('auth/isTokenExpired').then((response) => {
      if (response) {
        this.logout()
        return
      }
      this.$store.dispatch('app/boot', 'app')
    })
    Bus.$on('alert', ({ color, message }) => {
      this.statusShown = true
      this.statusColor = color
      this.statusMessage = message
    })
    setInterval(() => {
      this.$store.dispatch('auth/isTokenExpired').then((response) => {
        if (response) {
          this.inactiveLogoutPrompt = response
        }
      })
    }, 3000)
  },
  onIdle () {
    if (this.$store.state.auth.authenticated) {
      this.showOptionDialog = true
      this.intervalId = window.setTimeout(this.logout, this.autoLogoutTime)
    }
  },
  computed: {
    isArray () {
      return this.statusMessage instanceof Object && this.statusMessage.constructor === Array
    },
    keepAlive () {
      return this.$store.state.auth.authenticated
        ? 'SearchAccounts,VerifyAccounts'
        : ''
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.clearDialog()
        this.$router.push('/login')
      })
    },
    refresh () {
      this.clearDialog()
    },
    clearDialog () {
      window.clearTimeout(this.intervalId)
      this.showOptionDialog = false
    },
    closeInactivePrompt () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push('/login')
        this.inactiveLogoutPrompt = false
      })
    }
  }
}
</script>

<style lang="sass">
dl
  dt
    float: left
    font-weight: bold
    margin-right: 10px
    padding: 5px
    width: 150px
  dd
    margin: 2px 0
    padding: 5px 0
    text-overflow: ellipsis
    display: flex

.accounts-table .v-datatable
  th:last-child, td:last-child
    text-align: right

.mt-10px
  margin-top: 10px

.mt--10px
  margin-top: -10px

.container
  max-width: none !important

.v-stepper__label
  white-space: nowrap
</style>
